"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTriggerProps = void 0;
var call_both_1 = require("./call-both");
/**
 * 返回默认 Trigger 需要使用的属性，使得气泡类组件可直接包裹当前组件
 *
 * @param props 组件 Props
 * @param occupiedProps 已被使用的事件 Props
 */
function getTriggerProps(props, occupiedProps) {
    if (occupiedProps === void 0) { occupiedProps = {}; }
    var triggerProps = {};
    ['onClick', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur'].forEach(function (key) {
        triggerProps[key] = (0, call_both_1.callBoth)(occupiedProps[key], props[key]);
    });
    return triggerProps;
}
exports.getTriggerProps = getTriggerProps;
